import React, { useState, useEffect, useMemo } from "react";
import Grid from "@mui/material/Grid";
import LoginComponent from "./loginComponent";
import AppUpdate from "../AppUpdate";
import PureJSComponentFactory from "./Pages/Factory/pureJSComponentFactory";
import { offlineLayoutInfo } from "../General/globals";
import PopupComponent from "./popupComponent";
import UnauthStartPage from "./unAuthStartPage";
import HttpService from "../Services/httpService";
import {
  unProcPath,
  apiRoot,
  authBody,
  showCustomUnAuthPage,
  jobId,
  authServiceInstance,
  useExternalLoginProviders,
  externalLoginProviderName,
} from "../General/globals";
import { useLocation } from "react-router-dom";
import { ownStore } from "../AppOwnState/ownState";
import { useMsal } from "@azure/msal-react";
import { ExecuteLayoutEventMethods } from "../General/commonFunctions";
import { showAppBusy, hideAppBusy } from "../AppOwnState";
import { ShowSnackBar } from "../General/globalFunctions";
import { GoogleLogin } from "@react-oauth/google";

const UnAuthorizedComponent = (props) => {
  const location = useLocation();
  const [unAuthUI, setUnAuthUI] = useState([]);

  const { instance, accounts } = useMsal();

  const pageFooter = useMemo(
    () =>
      new PureJSComponentFactory().scaffoldComponent(
        offlineLayoutInfo?.mainfooter
      ),
    []
  );
  const loginFooter = useMemo(
    () =>
      new PureJSComponentFactory().scaffoldComponent(
        offlineLayoutInfo?.loginfooter
      ),
    []
  );
  const loginSplitImage = useMemo(
    () =>
      new PureJSComponentFactory().scaffoldComponent(
        offlineLayoutInfo?.loginsplitimage
      ),
    []
  );

  const getStartPageUI = async () => {
    const pathNameStr = location.pathname || "";
    const searchStr = location.search || "";

    const queryString = searchStr.includes("?") ? searchStr.split("?")[1] : "";

    const params = new URLSearchParams(queryString);
    const queryObject = {};

    const coreData = ownStore.getState("appCoreData");

    for (const [key, value] of params.entries()) {
      queryObject[key] = value;
    }

    const data = {
      info: {
        doctype: "page",
        docno: "unauthorised-page",
        urlparams: pathNameStr,
        queryparams: queryObject,
      },
    };

    const headers = {
      "Content-Type": "application/json",
    };
    const reqBody = new HttpService().getProcPostBodyString(
      jobId || authBody?.job_id,
      "PWA.LoadLayout",
      data,
      "single"
    );
    let startUI = await new HttpService().postServer(
      apiRoot,
      unProcPath,
      headers,
      reqBody
    );
    const parsedUI = JSON.parse(startUI?.[0]?.layoutinfo)?.layout;
    const startPageUI = new PureJSComponentFactory().scaffoldComponent(
      parsedUI
    );

    setUnAuthUI(startPageUI);
  };

  useEffect(() => {
    if (showCustomUnAuthPage) {
      getStartPageUI();
    }
  }, []);

  const doSignInSSO = async (email, token) => {
    try {
      window.history.pushState(null, "Home", "/");
      ownStore.dispatch(showAppBusy());
      await authServiceInstance.SSOlogin(email, token);
      const authOK = await authServiceInstance.verifyLogin();
      if (authOK?.status) {
        if (authOK?.doNext) {
          ownStore.dispatch(hideAppBusy());
          try {
            const authEvents = JSON.parse(authOK.doNext);
            await ExecuteLayoutEventMethods(authEvents);
          } catch {}
          return;
        }
        authServiceInstance.continueLogin();
        return;
      }
    } catch (ex) {
      console.error(ex);
    }
    ownStore.dispatch(hideAppBusy());
    ShowSnackBar("error", "Login Failed!");
  };

  const MSALlogin = async () => {
    const loginResponse = await instance.loginPopup({
      scopes: ["User.Read"],
    });

    const tokenResponse = await instance.acquireTokenSilent({
      account: loginResponse.account,
      scopes: ["User.Read"],
    });

    const res = await fetch("https://graph.microsoft.com/v1.0/me", {
      headers: {
        Authorization: `Bearer ${tokenResponse.accessToken}`,
      },
    });
    const profile = await res.json();
    await doSignInSSO(profile.mail, tokenResponse.idToken);
  };

  const handleLoginSuccess = async (credentialResponse) => {
    // console.log("Google Credential Response:", credentialResponse);
    await doSignInSSO(null, credentialResponse.credential);
  };
  const handleLoginError = () => {
    console.error("Login Failed");
  };

  if (showCustomUnAuthPage) {
    return (
      <UnauthStartPage routerProps={props.routerProps} startUI={unAuthUI} />
    );
  } else {
    if (loginSplitImage) {
      return (
        <>
          <div className="login-container">
            <div container className="login-grid">
              <div className="left">
                <AppUpdate />
                <LoginComponent />
              </div>
              <div className="right">{loginSplitImage}</div>
              <div className="right">{pageFooter}</div>
            </div>
          </div>
          <PopupComponent />
        </>
      );
    } else {
      return (
        <>
          <div className="login-container">
            <div className="update-container">
              <AppUpdate />
            </div>
            {useExternalLoginProviders ? (
              <>
                {externalLoginProviderName === "GOOGLE" && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100vh",
                      width: "100%",
                      position: "fixed",
                      top: 0,
                      left: 0,
                      background: "rgba(0, 0, 0, 0)",
                      zIndex: 10000,
                      fontFamily: "Segoe UI, sans-serif",
                    }}
                  >
                    <div
                      style={{
                        background: "linear-gradient(135deg, #f0f4ff, #d9e4ff)",
                        padding: "40px 35px",
                        borderRadius: "15px",
                        boxShadow: "0 12px 30px rgba(0,0,0,0.2)",
                        textAlign: "center",
                        minWidth: "320px",
                        maxWidth: "400px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                        alignItems: "center",
                      }}
                    >
                      <h2
                        style={{
                          margin: 0,
                          color: "#1a1a1a",
                          fontSize: "22px",
                          fontWeight: "600",
                        }}
                      >
                        Please login to continue.
                      </h2>
                      {/* <p
                        style={{
                          margin: 0,
                          color: "#333",
                          fontSize: "16px",
                          lineHeight: "1.5",
                        }}
                      >
                        Your session has expired. Please log in again to
                        continue.
                      </p> */}
                      <GoogleLogin
                        width={300}
                        onSuccess={handleLoginSuccess}
                        onError={handleLoginError}
                      />
                    </div>
                  </div>
                )}

                {externalLoginProviderName === "MSAL" && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100vh",
                      width: "100%",
                      position: "fixed",
                      top: 0,
                      left: 0,
                      background: "rgba(0,0,0,0.6)",
                      zIndex: 10000,
                      fontFamily: "Segoe UI, sans-serif",
                    }}
                  >
                    <div
                      style={{
                        background: "linear-gradient(135deg, #f0f4ff, #d9e4ff)",
                        padding: "40px 35px",
                        borderRadius: "15px",
                        boxShadow: "0 12px 30px rgba(0,0,0,0.2)",
                        textAlign: "center",
                        minWidth: "320px",
                        maxWidth: "400px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                        alignItems: "center",
                      }}
                    >
                      <h2
                        style={{
                          margin: 0,
                          color: "#1a1a1a",
                          fontSize: "22px",
                          fontWeight: "600",
                        }}
                      >
                        Please login to continue.
                      </h2>
                      {/* <p
                        style={{
                          margin: 0,
                          color: "#333",
                          fontSize: "16px",
                          lineHeight: "1.5",
                        }}
                      >
                        Your session has expired. Please log in again to
                        continue.
                      </p> */}
                      <button
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "12px",
                          padding: "12px 25px",
                          cursor: "pointer",
                          fontSize: "16px",
                          fontWeight: "500",
                          borderRadius: "10px",
                          border: "none",
                          background:
                            "linear-gradient(90deg, #0078D4, #00A0F1)",
                          color: "#fff",
                          transition: "all 0.3s ease",
                        }}
                        onClick={MSALlogin}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.filter = "brightness(1.1)")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.filter = "brightness(1)")
                        }
                      >
                        <img
                          width="28px"
                          height="28px"
                          src="/Microsoft_logo.png"
                          alt="Microsoft logo"
                        />
                        Login with Microsoft
                      </button>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <Grid container className="login-grid">
                <Grid item lg={4} sm={2}></Grid>
                <Grid item lg={4} sm={8}>
                  <LoginComponent />
                </Grid>
                <Grid item lg={4} sm={2}></Grid>
              </Grid>
            )}

            {pageFooter}
          </div>
          <PopupComponent />
        </>
      );
    }
  }
};

export default UnAuthorizedComponent;
